<template>
	<pre v-html="$t('terms.agreement5')"></pre>
</template>

<script>
export default {
	name: 'Agreement5',
};
</script>

<style scoped></style>
